import React from "react";
import "../css/Services.css";

const Services = () => {
  return (
    <div className="services4">

      {/* ================= HERO ================= */}
      <section className="srv-hero">
        <h1>What We Offer</h1>
        <p>Playful fitness. Smart progress. A Shank experience built for joy.</p>
      </section>

      {/* Floating blobs */}
      <div className="srv-blob b1"></div>
      <div className="srv-blob b2"></div>


      {/* ================= TILTED FUN SERVICE CARDS ================= */}
      <section className="srv-cards">
      
        <div className="srv-card tilt-left">
          <h2>Fun Group Classes</h2>
          <p>Dance, HIIT, rhythm workouts — fitness with a smile.</p>
        </div>
      
        <div className="srv-card tilt-right">
          <h2>Personal Coaching</h2>
          <p>1-on-1 sessions shaped around your style and goals.</p>
        </div>
      
        <div className="srv-card tilt-left">
          <h2>Smart Progress Tracking</h2>
          <p>Visual charts and weekly insights to keep you improving.</p>
        </div>
      
        <div className="srv-card tilt-right">
          <h2>Nutrition Support</h2>
          <p>Simple, tasty, practical guidance for everyday life.</p>
        </div>
      
      </section>


      {/* ================= DIAGONAL SPLIT PANEL ================= */}
      <section className="srv-diagonal">

        <div className="diag-left">
          <h1>Move Freely</h1>
          <p>
            At Shank, workouts are joyful, stress-free, and full of playful energy.
            Whether you dance, lift, stretch, or sweat — we help you stay consistent
            with training that feels genuinely fun.
          </p>
        </div>

        <div className="diag-right">
          <img
            src="https://images.pexels.com/photos/3768690/pexels-photo-3768690.jpeg"
            alt="service"
          />
        </div>

      </section>


      {/* ================= VERTICAL TIMELINE ================= */}
      <section className="srv-timeline">
        <h2 className="timeline-title">How Shank Works</h2>

        <div className="timeline-wrapper">

          <div className="tl-item">
            <div className="tl-dot"></div>
            <h3>Step 1 — Start</h3>
            <p>Pick your vibe: group classes, solo workouts, or personal coaching.</p>
          </div>

          <div className="tl-item">
            <div className="tl-dot"></div>
            <h3>Step 2 — Train</h3>
            <p>Join fun sessions or explore our guided routines at your own pace.</p>
          </div>

          <div className="tl-item">
            <div className="tl-dot"></div>
            <h3>Step 3 — Track</h3>
            <p>Weekly insights help you understand your training patterns.</p>
          </div>

          <div className="tl-item">
            <div className="tl-dot"></div>
            <h3>Step 4 — Glow</h3>
            <p>Celebrate results with a fitness lifestyle that feels rewarding.</p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Services;
